import React, { Component } from 'react';
import { Modal, TextInput } from 'sure-components';
import Button from 'shared/lib/components/Button';
import get from 'lodash/get';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import Spinner from 'shared/lib/components/Spinner';
import CreditCardField from 'shared/lib/components/CreditCardField';
import Select from 'react-select';
import IntlTelInput from 'react-intl-tel-input';
import * as analytics from 'shared/lib/analytics';
import 'react-intl-tel-input/dist/libphonenumber.js';
import 'react-intl-tel-input/dist/main.css';
import './Settings.css';

export default class Settings extends Component {
  constructor(props) {
    super(props);
    this.MODALS = {
      ADD_PAYMENT_METHOD: 'ADD_PAYMENT_METHOD',
      DELETE_PAYMENT_METHOD: 'DELETE_PAYMENT_METHOD',
    };
    this.state = {
      isAddPaymentMethodEnabled: false,
      selectedCountryId: get(this.props.account, 'country.id', ''),
      selectedRegionId: get(this.props.account, 'region.id'),
      regions: [],
      activeModal: null,
    };
  }

  componentDidMount() {
    document.title = 'Account Settings - Sure';

    this.props
      .getL10n()
      .then(this.props.getAccountInfo)
      .then(() => {
        this.handleCountryChange({
          value: get(this.props.account, 'country.id'),
        });
        this.handleRegionChange({
          value: get(this.props.account, 'region.id'),
        });
      });
  }

  get countriesOptions() {
    return map(this.props.countries, country => {
      return {
        value: country.id,
        label: country.name,
      };
    });
  }

  get paymentMethodNode() {
    if (!this.props.account.paymentMethods[0]) {
      return 'No payment method found.';
    }

    const paymentMethod = this.props.account.paymentMethods[0];
    // New updated payment methods contain id
    if (!!paymentMethod.id) {
      return (
        <li className="Settings-paymentMethods-item">
          <div className="Settings-paymentMethods-item-info">
            {paymentMethod.name}
          </div>
        </li>
      );
    }
    // Older payment methods contain public_id
    if (!!paymentMethod.public_id) {
      return (
        <li className="Settings-paymentMethods-item">
          <div className="Settings-paymentMethods-item-info">
            {paymentMethod.details.brand} &#8226;&#8226;&#8226;&#8226;{' '}
            {paymentMethod.details.last4}
          </div>
        </li>
      );
    }

    return 'Error retrieving payment method.';
  }

  get settingsNode() {
    return (
      <div className="Container Container--small">
        <div>
          <form onSubmit={this.handleSubmit.bind(this)}>
            <fieldset className="Settings-fieldset">
              <legend className="Settings-legend">Your Account Details</legend>
              <label className="Settings-label">First Name</label>
              <TextInput
                name="firstName"
                placeholder="First Name"
                required
                defaultValue={this.props.account.firstName}
                ref={c => (this.inputFirstName = c)}
              />
              <label className="Settings-label">Middle Name</label>
              <TextInput
                name="middleName"
                placeholder="Middle Name (optional)"
                defaultValue={this.props.account.middleName}
                ref={c => (this.inputMiddleName = c)}
              />
              <label className="Settings-label">Last Name</label>
              <TextInput
                name="lastName"
                placeholder="Last Name"
                required
                defaultValue={this.props.account.lastName}
                ref={c => (this.inputLastName = c)}
              />
              <label className="Settings-label">Email</label>
              <TextInput
                name="email"
                placeholder="Email"
                required
                disabled
                defaultValue={this.props.account.email}
                ref={c => (this.inputEmail = c)}
              />
              <label className="Settings-label">Phone Number</label>
              <IntlTelInput
                css={['intl-tel-input', 'form-control Settings-input']}
                style={{ width: '100%', marginBottom: '10px' }}
                defaultValue={this.props.account.phoneNumber}
                defaultCountry="auto"
                preferredCountries={['us', 'za', 'gb']}
                autoHideDialCode={false}
                nationalMode={false}
                geoIpLookup={this.handleGeoIpLookup}
                onPhoneNumberBlur={this.handlePhoneNumberChange.bind(this)}
                onPhoneNumberChange={this.handlePhoneNumberChange.bind(this)}
                utilsScript={'libphonenumber.js'}
              >
                Phone Number
              </IntlTelInput>
            </fieldset>
            <fieldset
              className="Settings-fieldset"
              id="country_region_form_fieldset"
            >
              <legend className="Settings-legend">
                Your Primary Residence
              </legend>
              <label className="Settings-label">Country</label>
              <Select
                className="SureSelect"
                name="country"
                options={this.countriesOptions}
                clearable={false}
                searchable={true}
                onChange={this.handleCountryChange.bind(this)}
                value={this.state.selectedCountryId}
              />
              <label className="Settings-label">State/Region</label>
              <Select
                className="SureSelect"
                name="region"
                options={this.state.regions}
                clearable={false}
                searchable={true}
                onChange={this.handleRegionChange.bind(this)}
                value={this.state.selectedRegionId}
              />
            </fieldset>
            <fieldset className="Settings-fieldset">
              <legend className="Settings-legend">
                Your Beneficiary Details
              </legend>
              <label className="Settings-label">
                First Name
                {this.props.beneficiaryFirstName}
              </label>
              <TextInput
                name="beneficiaryFirstName"
                placeholder="First Name (optional)"
                defaultValue={this.props.account.beneficiaryFirstName}
                ref={c => (this.inputBeneficiaryFirstName = c)}
              />
              <label className="Settings-label">Last Name</label>
              <TextInput
                name="beneficiaryLastName"
                placeholder="Last Name (optional)"
                defaultValue={this.props.account.beneficiaryLastName}
                ref={c => (this.inputBeneficiaryLastName = c)}
              />
              <label className="Settings-label">Email</label>
              <TextInput
                name="beneficiaryEmail"
                placeholder="Email (optional)"
                defaultValue={this.props.account.beneficiaryEmail}
                ref={c => (this.inputBeneficiaryEmail = c)}
              />
            </fieldset>

            <div className="Settings-ctaWrapper">
              <Button
                className="Settings-cta"
                type="submit"
                sureStyle="success"
              >
                Save Changes
              </Button>
            </div>
          </form>
          <div className="Settings-fieldset">
            <div className="Settings-legend">Your Payment Method</div>
            <ul className="Settings-paymentMethods">
              {this.paymentMethodNode}
            </ul>
          </div>
          <Button
            className="Settings-addPaymentMethodButton"
            sureStyle="outline"
            onClick={this.showAddPaymentMethodModal}
          >
            Update Payment Method
          </Button>
        </div>
      </div>
    );
  }

  get spinnerNode() {
    return <Spinner />;
  }

  get contentNode() {
    if (isEmpty(this.props.account)) {
      return this.spinnerNode;
    } else {
      return this.settingsNode;
    }
  }

  showAddPaymentMethodModal = () => {
    analytics.track('Portal - Update Payment Method Clicked');
    this.setState({
      activeModal: this.MODALS.ADD_PAYMENT_METHOD,
    });
  };

  showDeletePaymentMethodModal = () => {
    analytics.track('Portal - Delete Payment Method Clicked');
    this.setState({
      activeModal: this.MODALS.DELETE_PAYMENT_METHOD,
    });
  };

  hideModals = () => {
    this.setState({
      activeModal: null,
    });
  };

  handleGeoIpLookup(callback) {
    window.geoip2.insights(data => {
      let countryCode = data && data.country ? data.country.iso_code : '';
      callback(countryCode);
    });
  }

  handlePhoneNumberChange(status, value) {
    this._phoneNumber = value;
  }

  handleCreditCardFormChange(e) {
    this.setState({
      isAddPaymentMethodEnabled: e.isComplete,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    analytics.track('Portal - Account Save Clicked', { category: 'user' });

    const accountData = {
      firstName: this.inputFirstName.value,
      middleName: this.inputMiddleName.value,
      lastName: this.inputLastName.value,
      phoneNumber: this._phoneNumber || this.props.account.phoneNumber,
      beneficiaryFirstName: this.inputBeneficiaryFirstName.value || null,
      beneficiaryLastName: this.inputBeneficiaryLastName.value || null,
      beneficiaryEmail: this.inputBeneficiaryEmail.value || null,
      countryId: this.state.selectedCountryId,
      regionId: this.state.selectedRegionId,
    };

    this.props
      .updateAccountInfo(accountData)
      .then(() => {
        this.props.showToast('Account settings saved', 'success');
      })
      .catch(errorMessage => {
        this.props.showToast(errorMessage, 'error');
      });
  }

  handleCountryChange(e) {
    const selectedCountry = find(this.props.countries, { id: e.value });
    const regions = map(
      (selectedCountry && selectedCountry.regions) || [],
      region => {
        return {
          value: region.id,
          label: region.name,
        };
      }
    );

    this.setState({
      selectedCountryId: (selectedCountry && selectedCountry.id) || '',
      regions,
    });
  }

  handleRegionChange(e) {
    this.setState({
      selectedRegionId: e.value,
    });
  }

  handleAddPaymentMethod(e) {
    e.preventDefault();
    analytics.track('Portal - Update Payment Method Save Clicked', {
      category: 'user',
    });

    this.props
      .addPaymentMethod(this.creditCardField.elements.cardElement)
      .then(this.hideModals)
      .then(() => {
        analytics.track('Portal - Update Payment Method Save Success', {
          category: 'user',
        });
        this.props.showToast('Payment method updated', 'success');
        this.creditCardField.reset();
        this.setState({
          isAddPaymentMethodEnabled: false,
        });
      })
      .catch(error => {
        analytics.track('Portal - Update Payment Method Save Error', {
          category: 'user',
        });
      });
  }

  handleDeletePaymentMethod(paymentMethod) {
    analytics.track('Portal - Payment Method Delete Clicked', {
      category: 'user',
    });
    this._deletingPaymentMethod = paymentMethod;
    this.showDeletePaymentMethodModal();
  }

  handleDeletePaymentMethodConfirm() {
    analytics.track('Portal - Payment Method Delete Confirmed', {
      category: 'user',
    });
    this.props
      .deletePaymentMethod(this._deletingPaymentMethod.public_id)
      .then(() => {
        analytics.track('Portal - Payment Method Delete Success', {
          category: 'user',
        });
        this.props.showToast(
          `${this._deletingPaymentMethod.details.brand} ${
            this._deletingPaymentMethod.details.last4
          } deleted`,
          'success'
        );
      })
      .catch(error => {
        analytics.track('Portal - Payment Method Delete Failure', {
          category: 'user',
        });
      });
    this.hideModals();
  }

  render() {
    return (
      <div className="Settings">
        {this.contentNode}

        <Modal
          className="Settings-addPaymentMethodModal"
          title="Update Payment Method"
          isActive={this.state.activeModal === this.MODALS.ADD_PAYMENT_METHOD}
          onDismiss={this.hideModals}
        >
          <form
            className="Settings-addPaymentMethodModal-form"
            onSubmit={e => this.handleAddPaymentMethod(e)}
          >
            <CreditCardField
              ref={c => (this.creditCardField = c)}
              disabled={this.props.isAddPaymentMethodInProgress}
              onChange={this.handleCreditCardFormChange.bind(this)}
            />
            <Button
              disabled={
                !this.state.isAddPaymentMethodEnabled ||
                this.props.isAddPaymentMethodInProgress
              }
            >
              Update
            </Button>
          </form>
        </Modal>

        {this.state.activeModal === this.MODALS.DELETE_PAYMENT_METHOD && (
          <Modal
            className="Settings-deletePaymentMethodModal"
            title="Delete Payment Method"
            isActive={true}
            onDismiss={this.hideModals}
          >
            <p>
              Are you sure you want to delete{' '}
              {this._deletingPaymentMethod.details.brand}{' '}
              &#8226;&#8226;&#8226;&#8226;{' '}
              {this._deletingPaymentMethod.details.last4}?
            </p>
            <div className="Settings-deletePaymentMethodModal-actions">
              <Button sureStyle="outline" onClick={this.hideModals}>
                Cancel
              </Button>
              <Button
                onClick={this.handleDeletePaymentMethodConfirm.bind(this)}
              >
                Confirm
              </Button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}
